// extracted by mini-css-extract-plugin
export default {"numberInput":"NumberInput_numberInput__g8dZc","button":"NumberInput_button__uwPVF","less":"NumberInput_less__VJVq0","more":"NumberInput_more__MmhY2"};